import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useAuctionCarsCarEnterHotbid() {
  const { startListen } = useWebSocketStore()
  const { updateAuctionCar } = useUpdateCar()

  const carEnterHotbid = () => {
    startListen({
      eventName: 'premium.CAR_ENTER_HOTBID',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId, start, auctionId } = event.context

        updateAuctionCar(auctionId, carId, (data) => {
          return {
            ...data,
            inActiveHotbidPhase: true,
            hotbidStartTime: new Date(start).toISOString(),
          }
        })
      },
    })
  }

  return { carEnterHotbid }
}
